import PropTypes from "prop-types";

import { StyledToolTip } from "./Tooltip.styles";

const Tooltip = ({ text, enabled, children, ...rest }) =>
    enabled && text ? (
        <StyledToolTip title={<span style={{ whiteSpace: "pre-line" }}>{text}</span>} {...rest}>
            {children}
        </StyledToolTip>
    ) : (
        children
    );

Tooltip.defaultProps = {
    placement: "bottom",
    enterDelay: 2000,
    leaveDelay: 0,
    enabled: true,
};

Tooltip.propTypes = {
    text: PropTypes.any,
    enabled: PropTypes.bool,
    children: PropTypes.node,
    placement: PropTypes.string,
    enterDelay: PropTypes.number,
    leaveDelay: PropTypes.number,
};

export default Tooltip;
